var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadConfirmationDialogStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 154.1 114.2",
    style: {
      enableBackground: "new 0 0 154.1 114.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n#Group_1804 .st0 {\n  fill: #ffffff;\n}\n.clonoseq-theme #Group_1804 .st1 {\n  fill: none;\n  stroke: #67b8db;\n}\n.immunoseq-theme #Group_1804 .st1 {\n  fill: none;\n  stroke: #e9903f;\n}\n.clonoseq-theme #Group_1804 .st2 {\n  fill: #67b8db;\n}\n.immunoseq-theme #Group_1804 .st2 {\n  fill: #e9903f;\n}\n.clonoseq-theme #Group_1804 .st3 {\n  fill: none;\n  stroke: #67b8db;\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n.immunoseq-theme #Group_1804 .st3 {\n  fill: none;\n  stroke: #e9903f;\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    transform: "translate(-1111 -229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_185",
    transform: "translate(1111 285)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,9.1h91c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-91c-1.1,0-2-0.9-2-2v-11C29.5,10,30.4,9.1,31.5,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,9.6h91c0.8,0,1.5,0.7,1.5,1.5v11c0,0.8-0.7,1.5-1.5,1.5h-91c-0.8,0-1.5-0.7-1.5-1.5v-11 C30,10.2,30.7,9.6,31.5,9.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_186",
    transform: "translate(1111 305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,9.1h91c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-91c-1.1,0-2-0.9-2-2v-11C29.5,10,30.4,9.1,31.5,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,9.6h91c0.8,0,1.5,0.7,1.5,1.5v11c0,0.8-0.7,1.5-1.5,1.5h-91c-0.8,0-1.5-0.7-1.5-1.5v-11 C30,10.2,30.7,9.6,31.5,9.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_65_1",
    transform: "translate(1134 229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    className: "st2",
    d: "M54,9.1C40.5,9.1,29.5,20,29.5,33.5S40.5,57.9,54,57.9S78.4,47,78.4,33.5 C78.4,20,67.5,9.1,54,9.1C54,9.1,54,9.1,54,9.1z M54,18.5c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7 S49.2,18.5,54,18.5L54,18.5z M54,52.4c-5.6,0-10.8-2.5-14.4-6.7c1.9-3.6,5.6-5.9,9.7-5.9c0.2,0,0.5,0,0.7,0.1 c1.3,0.4,2.7,0.7,4,0.7c1.4,0,2.7-0.2,4-0.7c0.2-0.1,0.5-0.1,0.7-0.1c4.1,0,7.8,2.3,9.7,5.9C64.8,49.9,59.5,52.4,54,52.4L54,52.4z "
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    className: "st3",
    x1: 1151,
    y1: 301.6,
    x2: 1225,
    y2: 301.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    className: "st2",
    cx: 1153,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    className: "st2",
    cx: 1163,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    className: "st2",
    cx: 1173,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    className: "st2",
    cx: 1183,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    className: "st2",
    cx: 1193,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    className: "st2",
    cx: 1203,
    cy: 321.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    className: "st2",
    cx: 1213,
    cy: 321.6,
    r: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadConfirmationDialogStep3);
export default __webpack_public_path__ + "static/media/UploadConfirmationDialog_Step3.7b8472a2.svg";
export { ForwardRef as ReactComponent };